// ============================================================
// MÉDIAS IMMERSIFS — Pages Expériences internes
// ------------------------------------------------------------
// Posters : chemins statiques locaux `/media/images/experiences/*`.
//           Ils passent tous par `mediaUrl(...)` côté rendu, donc
//           l'admin peut les remplacer via la médiathèque et le
//           cache Cloudflare est invalidé grâce au timestamp.
// Vidéos  : URLs CDN Emergent stables (customer-assets). Peuvent
//           être `null` (ex. bain de fleurs) → le hero reste alors
//           une belle image fixe animée par un léger Ken-Burns.
// Audio   : `null` pour l'instant — les anciennes URLs pointaient
//           vers un projet Emergent désactivé (romance-decors).
// ============================================================

export const IMMERSIVE = {
  "bain-de-fleurs": {
    slug: "bain-de-fleurs",
    title: "Bain de fleurs",
    subtitle: "Un bain fleuri préparé pour vous, dans le calme du jardin.",
    overline: "Le Curieux Refuge",
    hero: {
      // Belle image fixe du bain fleuri (modifiable via admin → Médiathèque).
      poster: "/media/images/experiences/bain-de-fleurs.png",
      // Pas de vidéo : l'ancienne vidéo montrait un intérieur de chambre
      // qui portait à confusion. Le poster suffit à porter l'ambiance.
      video: null,
      audio: null,
    },
    gallery: [
      {
        src: "/media/images/experiences/bain-de-fleurs.png",
        alt: "Bain de fleurs préparé dans le jardin",
      },
    ],
  },

  "petit-dejeuner": {
    slug: "petit-dejeuner",
    title: "Petit déjeuner du Refuge",
    subtitle: "Servi au refuge, dans un cadre calme et intime.",
    overline: "Le Curieux Refuge",
    hero: {
      poster: "/media/images/experiences/petit-dejeuner-1.png",
      video: "https://customer-assets.emergentagent.com/job_romance-decors/artifacts/21via0mf_18d0047b88a64789a30f1be7ea8903ae.mov",
      audio: null,
    },
    gallery: [
      {
        src: "https://customer-assets.emergentagent.com/job_romance-decors/artifacts/rhmlrsyk_0807FACE-597C-4463-B239-691848563112.png",
        alt: "Table dressée avec fruits, pain, confitures et jus d'orange",
      },
      {
        src: "https://customer-assets.emergentagent.com/job_romance-decors/artifacts/8u4i6ze5_8CA11EC5-32E3-4661-939B-76EE63CF05E1.png",
        alt: "Petit déjeuner avec fruits frais et café fumant",
      },
      {
        src: "https://customer-assets.emergentagent.com/job_romance-decors/artifacts/1v5ug7v4_1E9CB955-D044-4A1A-A6DA-66B438AD9247.png",
        alt: "Table dressée sous la pergola du refuge",
      },
    ],
  },

  decors: {
    slug: "decors",
    title: "Décors du Refuge",
    subtitle: "Des ambiances décorées pour célébrer votre séjour.",
    overline: "Le Curieux Refuge",
    hero: {
      poster: "/media/images/experiences/decor-nuit-rouge.png",
      video: "https://customer-assets.emergentagent.com/job_romance-decors/artifacts/p9dvc3db_RPReplay_Final1776339998.mov",
      audio: null,
    },
    gallery: [
      {
        src: "https://customer-assets.emergentagent.com/job_83d2dd7c-b8fa-4317-9dcd-1ec71bead410/artifacts/r8gltfqq_2A707590-0455-4E7E-8FA3-3272B78CAC60.png",
        alt: "Lit décoré de pétales et bougies — Nuit Rouge",
      },
      {
        src: "https://customer-assets.emergentagent.com/job_83d2dd7c-b8fa-4317-9dcd-1ec71bead410/artifacts/s1bbtmzq_IMG_0829.jpeg",
        alt: "Chandelier romantique avec roses",
      },
      {
        src: "https://customer-assets.emergentagent.com/job_romance-decors/artifacts/fdxicf9n_6843AA91-2ECE-40D1-9E52-1A025694AE50.png",
        alt: "Terrasse du refuge avec bassin et chambre décorée",
      },
    ],
  },
};

export default IMMERSIVE;
